import React, {
	useLayoutEffect,
	forwardRef,
	ReactElement,
	useContext,
	useEffect,
	useCallback,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ISubHeaderProps } from '../SubHeader/SubHeader';
import { IPageProps } from '../Page/Page';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../contexts/authContext';
import { useState } from 'react';
import ConfigContext from '../../contexts/configContext';
import { demoPagesMenu } from '../../menu';
import { checkSession } from '../../apis';
import Button, { IButtonProps } from '../../components/bootstrap/Button';
import Widget from '../../components/Widget';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../components/bootstrap/Modal';
import LoadingPage from '../../components/LoadingPage';

interface IPageWrapperProps {
	isProtected?: boolean;
	title?: string;
	description?: string;
	children:
		| ReactElement<ISubHeaderProps>[]
		| ReactElement<IPageProps>
		| ReactElement<IPageProps>[];
	className?: string;
}
interface ButtonLinkMap {
	[key: string]: string | undefined;
}

const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
	({ isProtected, title, description, className, children }, ref) => {
		useLayoutEffect(() => {
			// @ts-ignore
			document.title = `${title ? `${title} | ` : ''}${
				process.env.REACT_APP_COMPANY_NAME || 'Default Company Name'
			}`;
			// @ts-ignore
			document
				?.querySelector('meta[name="description"]')
				.setAttribute('content', description || process.env.REACT_APP_META_DESC || '');
		});

		const { userData } = useContext(AuthContext);

		const [withdrawModalState, setWithdrawModalState] = useState(false);
		const [headerCloseStatus, setHeaderCloseStatus] = useState(true);
		const [showTrade, setShowTrade] = useState(false);
		const [loading, setLoading] = useState(true);
		const navigate = useNavigate();
		const token = userData.token || localStorage.getItem('ark_authToken') || undefined;
		const data = { ...userData, CompanyName: process.env.REACT_APP_COMPANY_NAME };
		const buttonLinkMap: ButtonLinkMap = {
			'Download For Android': process.env.REACT_APP_GOOGLEPLAY_LINK,
			'Download For iOS': process.env.REACT_APP_APPSTORE_LINK,
			'Download For Windows': process.env.REACT_APP_DESKTOPTRADER_LINK,
			'Launch Webtrader':
				process.env.REACT_APP_WEBTRADER_LINK +
				'externalLogin?token=' +
				userData.token +
				'&userData=' +
				encodeURIComponent(JSON.stringify(data)),
		};

		const sessionStatus = useCallback(async () => {
			if (isProtected) {
				if (!token) {
					setShowTrade(false);
					navigate(`../${demoPagesMenu.login.path}`);
				} else {
					setShowTrade(true);
					await checkSession(process.env.REACT_APP_ARKAPIURL, token);
				}
			} else {
				setShowTrade(false);
			}
			setLoading(false);
		}, [isProtected, navigate, token]);

		useEffect(() => {
			sessionStatus();
			const interval = setInterval(sessionStatus, 1000 * 60);
			return () => clearInterval(interval);
		}, [sessionStatus]);
		const handleClick = (buttonName: any) => {
			const link = buttonLinkMap[buttonName];

			if (link) {
				window.open(link, '_blank');
			}
		};
		// ✅ Show loading screen while checking session
		if (loading) {
			return <LoadingPage />;
		}

		return (
			<div ref={ref} className={classNames('page-wrapper', 'container-fluid', className)}>
				{showTrade && (
					<div className='d-flex justify-content-end px-2 pt-1'>
						<Button
							color='primary'
							onClick={() => {
								setWithdrawModalState(true);
							}}>
							Trade Now
						</Button>
					</div>
				)}
				{/* {showTrade && (
				)} */}
				<Widget />

				<Modal
					isOpen={withdrawModalState}
					setIsOpen={setWithdrawModalState}
					titleId='newWithdrawModal'
					isAnimation={true}
					isCentered={true}>
					<ModalHeader setIsOpen={headerCloseStatus ? setWithdrawModalState : undefined}>
						<ModalTitle id='newWithdrawModal'>{'Trade Now'}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<div className='d-flex flex-wrap'>
							{Object.keys(buttonLinkMap).map((name, index) => (
								<div
									key={index}
									className='w-50 d-flex justify-content-center align-items-center p-4'>
									<Button
										color='primary'
										style={{ height: '50px', width: '100%' }}
										onClick={() => handleClick(name)}>
										{name}
									</Button>
								</div>
							))}
						</div>
					</ModalBody>
				</Modal>
				{children}
			</div>
		);
	},
);
PageWrapper.displayName = 'PageWrapper';
PageWrapper.propTypes = {
	isProtected: PropTypes.bool,
	title: PropTypes.string,
	description: PropTypes.string,
	// @ts-ignore
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
PageWrapper.defaultProps = {
	isProtected: true,
	title: undefined,
	description: undefined,
	className: undefined,
};

export default PageWrapper;
